import { Outlet, RouteObject } from "react-router-dom";

export const warrantiesRoutes: RouteObject[] = [
  {
    element: <Outlet />,
    children: [
      {
        index: true,
        path: "",
        lazy: async () => {
          const { Page } =
            // redont-allow-dynamic-import: route-level code splitting
            await import("@redotech/redo-customer-portal-app/portal-four/shared-components/page");
          const { ThirdPartyWarranty } =
            // redont-allow-dynamic-import: route-level code splitting
            await import("@redotech/redo-customer-portal-warranties-app/third-party-warranty/third-party-warranty");
          return {
            element: (
              <Page>
                <ThirdPartyWarranty />
              </Page>
            ),
          };
        },
      },
      {
        path: "register",
        lazy: async () => {
          const { RegisterWarranty } =
            // redont-allow-dynamic-import: route-level code splitting
            await import("@redotech/redo-customer-portal-warranties-app/warranties/register-warranty");
          const { Page } =
            // redont-allow-dynamic-import: route-level code splitting
            await import("@redotech/redo-customer-portal-app/portal-four/shared-components/page");
          return {
            element: (
              <Page>
                <RegisterWarranty />
              </Page>
            ),
          };
        },
      },
      {
        path: ":warrantyId/warranty",
        lazy: async () => {
          const { Main } =
            await import("@redotech/redo-customer-portal-app/portal-four/submission/main");
          const { Page } =
            // redont-allow-dynamic-import: route-level code splitting
            await import("@redotech/redo-customer-portal-app/portal-four/shared-components/page");
          return {
            element: (
              <Page>
                <Main />
              </Page>
            ),
          };
        },
      },
      {
        path: "recycle-start",
        lazy: async () => {
          const { Main } =
            await import("@redotech/redo-customer-portal-app/portal-four/submission/main");
          const { Page } =
            // redont-allow-dynamic-import: route-level code splitting
            await import("@redotech/redo-customer-portal-app/portal-four/shared-components/page");
          return {
            element: (
              <Page>
                <Main />
              </Page>
            ),
          };
        },
      },
      {
        path: ":warrantyId/details",
        lazy: async () => {
          const { RegisteredWarrantyDetails } =
            // redont-allow-dynamic-import: route-level code splitting
            await import("@redotech/redo-customer-portal-warranties-app/warranties/registered-warranty-details");
          const { Page } =
            // redont-allow-dynamic-import: route-level code splitting
            await import("@redotech/redo-customer-portal-app/portal-four/shared-components/page");
          return {
            element: (
              <Page>
                <RegisteredWarrantyDetails />
              </Page>
            ),
          };
        },
      },
      {
        path: ":returnId",
        lazy: async () => {
          const { ReturnConfirmation } =
            await import("@redotech/redo-customer-portal-app/portal-four/returns/confirmation");
          const { Page } =
            // redont-allow-dynamic-import: route-level code splitting
            await import("@redotech/redo-customer-portal-app/portal-four/shared-components/page");
          return {
            element: (
              <Page>
                <ReturnConfirmation />
              </Page>
            ),
          };
        },
      },
    ],
  },
];
